import { Api } from './api';

export class QuizzesApi {
    private static readonly PATH = '/quizzes';

    constructor(private readonly m_api: Api) {}

    public async get() {
        return this.m_api.get(QuizzesApi.PATH);
    }

    public async getThemes(ignoreThemeIds: number[]) {
        return this.m_api.post(`${QuizzesApi.PATH}/get-themes`, { ignoreThemeIds });
    }

    public async requestQuestion() {
        return this.m_api.get(`${QuizzesApi.PATH}/question`);
    }

    public async start(interestId: number) {
        return this.m_api.post(`${QuizzesApi.PATH}/start`, { interestId });
    }

    public async finish() {
        return this.m_api.post(`${QuizzesApi.PATH}/finish`, {});
    }

    public async abort() {
        return this.m_api.post(`${QuizzesApi.PATH}/abort`, {});
    }

    public async answer(answerIndex: number) {
        return this.m_api.post(`${QuizzesApi.PATH}/answer`, { answerIndex });
    }
}